import * as R from 'ramda';
import { Action } from 'redux';
import { AppState } from './appState';
import ACTION_TYPE from './ActionTypes';
import { IUserPermissions } from '../models/user';

export type LogUserInAction = {
  type: ACTION_TYPE.LOG_USER_IN;
  isLoggedIn: boolean;
};

/**
 * Redux action to dispatch driver details
 * @param isLoggedIn - Type: boolean - if the user is logged in or not
 */
export const logUserIn = (isLoggedIn: boolean): LogUserInAction => ({
  type: ACTION_TYPE.LOG_USER_IN,
  isLoggedIn: isLoggedIn,
});

export const logUserInReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ACTION_TYPE.LOG_USER_IN) {
    return state;
  }
  return R.mergeDeepRight(state, {
    isLoggedIn: (action as LogUserInAction).isLoggedIn,
  });
};



// user Role Redux configure


// USER permission

export type userPermissionsAction = {
  type: ACTION_TYPE.USER_PERMISSION;
  userPermissions?: IUserPermissions;
};

/**
 * 
 * @param userPermissionsAction - Type: Permission - User's Permission
 */
export const userPermissions = (userPermissions: IUserPermissions | undefined): userPermissionsAction => ({
  type: ACTION_TYPE.USER_PERMISSION,
  userPermissions: userPermissions,
});

export const userPermissionsReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ACTION_TYPE.USER_PERMISSION) {
    return state;
  }
  return R.mergeDeepRight(state, {
    userPermissions: (action as userPermissionsAction).userPermissions,
  });
};

